import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import InputMask from 'react-input-mask'

import { Container } from '../../BulkEdit/EditInformations/styles'
import styled from 'styled-components'
import useAxios from 'axios-hooks'
import { toast } from 'react-toastify'

const WHATSAPP_NUMBER_LENGTH = 13
const CNPJ_LENGTH = 14

function isCnpjValid(cnpj) {
  if (!cnpj) return false

  const CNPJ_MULTIPLIERS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const parsedCnpj = cnpj.replace(/\D/g, '')
  const rootCnpj = parsedCnpj.slice(0, -2)

  if (parsedCnpj.length !== CNPJ_LENGTH) return false

  const firstDigitSum = Object.values(rootCnpj).reduce((acc, digit, index) => {
    return acc + digit * CNPJ_MULTIPLIERS[index + 1]
  }, 0)
  const firstDigit = firstDigitSum % 11 < 2 ? 0 : 11 - (firstDigitSum % 11)

  const newRootCnpj = rootCnpj + firstDigit
  const secondDigitSum = Object.values(newRootCnpj).reduce(
    (acc, digit, index) => {
      return acc + digit * CNPJ_MULTIPLIERS[index]
    },
    0
  )
  const secondDigit = secondDigitSum % 11 < 2 ? 0 : 11 - (secondDigitSum % 11)

  return firstDigit === +parsedCnpj[12] && secondDigit === +parsedCnpj[13]
}

const EditVariablesForm = ({ variables }) => {
  const intl = useIntl()
  const [whatsappNumber, setWhatsappNumber] = React.useState('')
  const [whatsappInvalid, setWhatsappInvalid] = React.useState(true)
  const [cnpj, setCnpj] = React.useState('')
  const [cnpjInvalid, setCnpjInvalid] = React.useState(true)
  const [isLoading, setIsLoading] = React.useState(false)
  const { locationId } = useParams()

  const [, updateLocationVariables] = useAxios(
    {
      url: `/locations/${locationId}/variables`,
      method: 'POST',
    },
    {
      manual: true,
    }
  )

  function handleChange(e) {
    const number = e.target.value
    const parsedNumber = number.replace(/\D/g, '')

    setWhatsappInvalid(
      parsedNumber.length !== WHATSAPP_NUMBER_LENGTH && parsedNumber
    )

    setWhatsappNumber(e.target.value)
  }

  function handleCNPJChange(e) {
    const cnpj = e.target.value
    const parsedCnpj = cnpj.replace(/\D/g, '')

    setCnpjInvalid(!isCnpjValid(parsedCnpj) && parsedCnpj)

    setCnpj(e.target.value)
  }

  async function handleSubmit(e) {
    setIsLoading(true)
    e.preventDefault()

    const parsedNumber = whatsappNumber.replace(/\D/g, '')
    const parsedCnpj = cnpj.replace(/\D/g, '')

    try {
      await updateLocationVariables({
        data: {
          whatsappNumber: parsedNumber,
          cnpj: parsedCnpj,
        },
      })
      toast.success(
        intl.formatMessage({ id: 'Variables updated successfully' })
      )
    } catch (error) {
      toast.error(intl.formatMessage({ id: 'Error while updating variables' }))
    }
    setIsLoading(false)
  }

  React.useEffect(() => {
    if (!variables) return

    const whatsapp = variables.whatsappNumber
    const cnpj = variables.cnpj

    setWhatsappNumber(whatsapp || '')
    setCnpj(cnpj || '')
    setWhatsappInvalid(whatsapp?.length !== WHATSAPP_NUMBER_LENGTH && whatsapp)
    setCnpjInvalid(!isCnpjValid(cnpj) && cnpj)
  }, [variables])

  return (
    <Container>
      <StyledForm>
        <label>
          <FormattedMessage id="Whatsapp Number:" />
        </label>
        <InputMask
          className="form-control"
          type="text"
          value={whatsappNumber}
          onChange={handleChange}
          mask="+99 (99) 99999-9999"
        ></InputMask>

        <label>
          <FormattedMessage id="CNPJ:" />
        </label>
        <InputMask
          className="form-control"
          type="text"
          value={cnpj}
          onChange={handleCNPJChange}
          mask="99.999.999/9999-99"
        ></InputMask>

        <button
          onClick={handleSubmit}
          disabled={whatsappInvalid || cnpjInvalid || isLoading}
        >
          <FormattedMessage id="Save Changes" />
        </button>
      </StyledForm>
    </Container>
  )
}

const StyledForm = styled.div`
  display: flex;
  flex-direction: column;

  button {
    width: fit-content;
    margin-top: 1rem;
    padding: 0.5rem 1rem;
    background-color: #7367f0;
    border-radius: 0.4rem;
    border: none;
    color: white;

    &:disabled {
      opacity: 0.65;
    }
  }
`

export default EditVariablesForm
